// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"364":"5ad1cb35","925":"5b85b1d7"}[chunkId] + ".chunk.js";
};